import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// shared components
import Loading from 'components/atoms/Loading'
import ErrorMessage from 'components/shared/ErrorMessage'
import RegistrationStep from 'components/register/shared/RegistrationStep'
import StripeWrapper from 'components/shared/StripeWrapper'

// data
import { useBrand } from 'components/shared/SettingsProvider'

// local components
import Form from './Form'
import Sweepstakes from './Sweepstakes'

const Payment = props => {
  const {
    loading, // via withQuery
    account, // via withQuery
    countries, // via withQuery
    states, // via withQuery
    customerSessionClientSecret, // via withQuery
    cartTotalCents, // via withQuery
    paymentProfileForm // via redux state
  } = props

  const { shortName, id: brandId } = useBrand()

  return (
    <RegistrationStep>
      <Box mt={2}>
        <ErrorMessage />
      </Box>

      <Typography mb={4} variant='body1'>
        Please add a payment method below. Paying with your bank account is the
        preferred payment method for {shortName}. It allows you to safely
        transfer funds directly from your account and will give you the chance
        to win one of our sweepstakes prizes. You will still be able to review
        and make changes on the next page.
      </Typography>

      {brandId === 'steveandkate' && <Sweepstakes />}

      {!account || !paymentProfileForm || loading ? (
        <Loading />
      ) : (
        <StripeWrapper
          mode='payment'
          amount={cartTotalCents || 100}
          currency='usd'
          account={account}
          customerSessionClientSecret={customerSessionClientSecret}
        >
          <Form account={account} countries={countries} states={states} />
        </StripeWrapper>
      )}
    </RegistrationStep>
  )
}

export default Payment
